import { useEffect, useState } from "react";
import { memberAPI } from "../../../api/memberAPI";
import { useLocation, useNavigate } from "react-router-dom";
import Spinner from "../../../components/spinner";
import './style.css';
import { IoIosArrowBack } from "react-icons/io";

export default function PreviewListView() {
    const [memberDetails, setMemberDetails] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const filters = location.state?.filters || {};
        getMemberDetailsListView(filters);
    }, [location.state]);

    const getHeading = () => {
        const filters = location.state?.filters || {};

        if (filters.filteration === 'renewed') {
            return `Member Details (RENEWED) ${filters.membershipYear}`;
        } else if (filters.filteration === 'not-renewd') {
            return `Member Details (NOT-RENEWED) ${filters.membershipYear}`;
        } else if (filters.filteration === 'all') {
            return 'Member Details (ALL)';
        } else {
            return 'Member Details';
        }
    };

    const getMemberDetailsListView = (filters) => {
        setIsLoading(true);

        memberAPI.getMemberDetailList(filters)
            .then((res) => {                
                const transformedData = res.map(item => ({
                    membershipNo: item.CusCode,
                    name: item.CusName,
                    address: item.CusAdd,
                    email: item.CusEmail,
                    mobile: item.CusMobile,
                    telephone: item.CusTel,
                    membershipType: item.MemberName,
                    membershipDate: item.MembershipDate,
                    outstanding: item.Outstanding,
                    paymentStatus: item.PaymentStatus,
                    membershipYear: item.MembershipYear,
                    isRenewed: item.isRenewed
                }));

                setMemberDetails(transformedData);
            })
            .catch(error => {
                console.error('Error fetching member details:', error);
            })
            .finally(() => setIsLoading(false));
    }

    const onPreviewMemberDetails = (memberCode) => () => {
        window.open(`/mainmenu/memberregistration/${memberCode}`, '_blank');
    };

    return (
        <div className="container form__body">
            {isLoading ? (
                <div className="text-center"><Spinner /></div>
            ) : (
                <>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <button
                            type="button"
                            className="btn  border border-0 d-flex align-items-center fs-3 p-2 pt-0 pb-0"
                            onClick={() => navigate('/mainmenu/memberdetails')}
                        ><IoIosArrowBack /></button>
                        <h4 className="text-center mb-0">{getHeading()}</h4>
                        <div style={{ width: '100px' }}></div> {/* Empty div for balance */}
                    </div>
                    <div className="member_table" style={{ overflowX: 'auto' }}>
                        <table className="table mt-1 table-striped table-hover">
                            <thead className="thead-dark" style={{
                                position: 'sticky',
                                top: 0,
                                zIndex: 1
                            }}>
                                <tr>
                                    <th scope="col">Membership No</th>
                                    <th scope="col">Name</th>
                                    <th className="text-center">Address</th>
                                    <th className="text-center">Email</th>
                                    <th scope="col">Mobile</th>
                                    <th scope="col" className="text-center">Tel</th>
                                    <th className="text-center">Membership Type</th>
                                    <th className="text-center">Membership Date</th>
                                    <th scope="col" className="text-center">Outstanding</th>
                                    <th scope="col" className="text-center">Year</th>
                                    <th scope="col" className="text-center">Renewed</th>
                                    <th className="text-center">Payment Status</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {memberDetails.length > 0 ? (
                                    memberDetails.map((member, index) => (
                                        <tr key={index}>
                                            <td>{member.membershipNo}</td>
                                            <td>{member.name}</td>
                                            <td className="text-left">{member.address || '-'}</td>
                                            <td className="text-center">{member.email || '-'}</td>
                                            <td className="text-right">{member.mobile || '-'}</td>
                                            <td className="text-right">{member.telephone || '-'}</td>
                                            <td className="text-center">{member.membershipType}</td>
                                            <td className="text-center">
                                                {member.membershipDate ? new Date(member.membershipDate).toLocaleDateString() : '-'}
                                            </td>
                                            <td className="text-right">{member.outstanding || '0.00'}</td>
                                            <td className="text-right">{member.membershipYear}</td>
                                            <td className="text-left">{member.isRenewed}</td>
                                            <td className="text-center">
                                                <span className={`badge ${member.paymentStatus === 'paid' ? 'bg-success' : 'bg-warning'}`}>
                                                    {member.paymentStatus || 'unpaid'}
                                                </span>
                                            </td>
                                            <td className="text-center">
                                                <button
                                                    type="button"
                                                    className="btn btn-dark btn-sm"
                                                    onClick={onPreviewMemberDetails(member.membershipNo)}
                                                >
                                                    View More
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="10" className="text-center">No members found matching the selected criteria</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </>
            )}
        </div>
    );
}